import { TSegment } from '@/features/segments/types';

function findSegmentByDate(segments: TSegment[], date: Date | string): TSegment | undefined {
  const d = date instanceof Date ? date : new Date(date);
  const time = d.getTime() / 1000;
  return segments.find(segment => {
    const start = new Date(segment.start_datetime).getTime() / 1000;
    const end = start + segment.duration_in_seconds;
    return time >= start && time <= end;
  });
}

/**
 * Checks if any segment overlaps the [startDate, endDate] interval.
 * @param segments Array of segments
 * @param startDate Start of the interval (Date or string)
 * @param endDate End of the interval (Date or string)
 * @returns true if any segment overlaps with the interval
 */
function isAnySegmentBetweenDates(
  segments: TSegment[],
  startDate: Date | string,
  endDate: Date | string
): boolean {
  const start = new Date(startDate).getTime() / 1000;
  const end = new Date(endDate).getTime() / 1000;

  return segments.some(seg => {
    const segmentStart = new Date(seg.start_datetime).getTime() / 1000;
    const segmentEnd = segmentStart + seg.duration_in_seconds;
    return (
      (segmentStart >= start && segmentStart <= end) ||
      (segmentEnd >= start && segmentEnd <= end) ||
      (segmentStart <= start && segmentEnd >= end)
    );
  });
}

function isCurrentTimeBetweenSegmentDates(
  clipStart: Date | null,
  clipEnd: Date | null,
  currentDate: Date
): boolean {
  if (!clipStart || !clipEnd) {
    return false;
  }

  const dateToCheck = new Date(currentDate).getTime() / 1000;

  return dateToCheck >= clipStart.getTime() / 1000 && dateToCheck <= clipEnd.getTime() / 1000;
}

export { findSegmentByDate, isAnySegmentBetweenDates, isCurrentTimeBetweenSegmentDates };
